export enum OddsModifiers {
    default = "default",
    changed = "changed",
    accepted = "accepted"
}